<template>
  <div class="data-grid-search-cascader">
    <el-cascader v-model="selectValue"
                 :options="optionList"
                 :props="cascaderProps"
                 :filterable="true"
                 collapse-tags
                 popper-class="data-grid-search-cascader-popper"
                 @visible-change="expandGridCascaderData"
                 style="width: 100%">
    </el-cascader>
  </div>
</template>

<script>
import baseApiUrl from '../../../constants/baseApiUrl'
import routeConfig from '../../../constants/routeConfig'
export default {
  name: 'DataGridSearchCascader',
  props: {
    value: {
      required: true
    },
    column: {
      type: Object,
      required: true
    },
    valueProp: {
      type: String,
      required: true
    },
    labelProp: {
      type: String,
      required: true
    },
    childrenProp: {
      type: String,
      required: true
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      loading: false,
      fetched: false,
      optionList: null
    }
  },
  computed: {
    cascaderProps () {
      return {
        value: this.valueProp,
        label: this.labelProp,
        children: this.childrenProp,
        multiple: this.multiple
      }
    },
    selectValue: {
      get () {
        const value = this.value
        let getVal
        if (this.multiple) {
          if (Array.isArray(value)) {
            getVal = value
          } else {
            getVal = value ? [value] : []
          }
        } else {
          if (Array.isArray(value)) {
            if (value.length) {
              const fVal = value[0]
              if (Array.isArray(fVal)) {
                getVal = fVal
              } else {
                getVal = fVal ? [fVal] : []
              }
            } else {
              getVal = []
            }
          } else {
            getVal = value ? [value] : []
          }
        }
        return getVal
      },
      set (value) {
        let setVal
        if (this.multiple) {
          setVal = value
        } else {
          setVal = value ? [value] : []
        }
        this.$emit('input', setVal)
      }
    }
  },
  methods: {
    // 展开级联框
    expandGridCascaderData (visible) {
      if (!visible) {
        return
      }
      if (!this.loading && !this.fetched) {
        let postParams = this.$extend(this.$attrs)
        if (!postParams[routeConfig.DataGrid.param]) {
          return
        }
        this.loading = true
        const loadingOption = {
          [this.labelProp]: '数据加载中...',
          [this.valueProp]: '数据加载中...',
          disabled: true
        }
        this.optionList = [loadingOption]
        let params = this.$extend({
          requestType: 'cascader',
          prop: this.column.prop
        }, postParams)
        this.$ajax({
          url: baseApiUrl.DataGridUrl,
          method: 'post',
          data: this.$qs.stringify(params, {
            arrayFormat: 'repeat'
          })
        }).then((response) => {
          if (response.data) {
            this.optionList = response.data['optionList']
            if (response.data['message'] && response.data['responseCode'] !== 'SUCCESS') {
              this.$message.error('级联数据加载出错')
            }
          }
          this.fetched = true
        }).catch(() => {
          this.optionList = null
        }).finally(() => {
          this.loading = false
        })
      }
    }
  },
  deactivated () {
    // 切换页面后重新加载
    this.fetched = false
  }
}
</script>

<style lang="scss">
  .data-grid-search-cascader {
    &>.el-cascader {
      width: 100%;
      .el-input--mini {
        .el-input__inner {
          height: 28px!important;
        }
      }
      .el-input--small {
        .el-input__inner {
          height: 32px!important;
        }
      }
      .el-input--medium {
        .el-input__inner {
          height: 36px!important;
        }
      }
      .el-cascader__tags {
        .el-cascader__search-input {
          min-width: 30px;
        }
      }
    }
  }
  .el-cascader__dropdown {
    &.data-grid-search-cascader-popper {
      .el-cascader-menu__wrap {
        .el-cascader-menu__list {
          .el-cascader-node {
            .el-cascader-node__label {
              font-size: 13px;
            }
            .el-checkbox {
              .el-checkbox__input {
                vertical-align: -2px;
              }
            }
          }
          .el-cascader-menu__empty-text {
            font-size: 13px;
          }
        }
      }
    }
  }
</style>
